export const EMAIL_VERIFICATION = 'onboarding/EMAIL_VERIFICATION';
export const ACTIVATE_PAYMENT_SOLUTION = 'onboarding/ACTIVATE_PAYMENT_SOLUTION';
export const SERVICE_LINE_LIST_REQUESTING =
	'onboarding/SERVICE_LINE_LIST_REQUESTING';
export const SERVICE_LINE_LIST_SUCCESS = 'onboarding/SERVICE_LINE_LIST_SUCCESS';
export const SERVICE_LINE_LIST_ERROR = 'onboarding/SERVICE_LINE_LIST_ERROR';
